<!--  -->
<template>
  <div class="order">
    <van-loading v-if="!showPage" size="24px" vertical>加载中...</van-loading>

    <div v-else>
      <van-nav-bar @click-left="onClickLeft" :title="title">
        <template #left>
          <van-icon name="arrow-left" color="black" size="14" />首页
        </template>
      </van-nav-bar>
      <div class="items">
        <van-card
          v-for="(item, index) in list"
          :key="index"
          :price="(item.Price / 100).toFixed(2)"
          :desc="`${item.OptionWeight}${item.OptionUnit}`"
          :title="item.OptionName"
          :num="item.Num"
          @click="toPage(item.ItemId)"
        >
          <template #thumb>
            <van-image width="88" height="88" :src="item.OptionImage">
              <template #error>
                <van-image
                  width="88"
                  height="88"
                  :src="`https://www.riceyfy.com${item.OptionImage}`"
                />
              </template>
            </van-image>
          </template>
        </van-card>
      </div>

      <div class="select-cell" :border="false">
        <van-cell-group>
          <van-cell
            :border="false"
            title="运费"
            :value="format_money(order.Postage)"
          />
          <van-cell
            :border="false"
            title="商家优惠券"
            :value="'-' + format_money(order.CouponsTotalStore)"
          />
          <van-cell
            :border="false"
            title="平台红包"
            :value="'-' + format_money(order.CouponsTotalYFY)"
          />
          <van-cell
            :border="false"
            title="总优惠"
            :value="
              '-' +
              format_money(Number(order.CouponTotal) + Number(order.PointTotal))
            "
          />
          <van-cell
            :border="false"
            class="oldTotal"
            title="原价"
            :value="format_money(order.ItemTotal)"
          />
          <van-cell :border="false" title="支付方式" :value="order.PayType" />
          <van-cell
            :border="false"
            title="支付状态"
            :value="order.IsPaid == 1 ? '已支付' : '未付款'"
          />

          <van-cell
            :border="false"
            v-if="order.PayTime"
            title="支付日期"
            :value="order.PayTime"
          />
          <van-cell :border="false" title="订单日期" :value="order.AddTime" />
          <van-field
            v-model="message"
            rows="3"
            autosize
            label="留言"
            type="textarea"
            input-align="right"
            readonly
          />

          <van-cell
            :border="false"
            class="total"
            title="实付金额"
            :value="format_money(order.Total)"
          />
        </van-cell-group>
      </div>
      <div class="btn" v-if="payBtn">
        <van-button size="large" @click="wxpay()" color="#ffc053"
          >立即支付</van-button
        >
      </div>
      <div class="btn" v-if="cancleBtn">
        <van-button size="large" @click="cancleOrder()" type="danger"
          >取消订单</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  Step,
  Steps,
  Card,
  Cell,
  Icon,
  CellGroup,
  NavBar,
  Button,
  Dialog,
  Image,
  Field,
} from "vant";
import api from "../../api/order";
// import wx from "weixin-js-sdk";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    [Button.name]: Button,
    [Step.name]: Step,
    [Card.name]: Card,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    [Dialog.name]: Dialog,
    [Steps.name]: Steps,
  },
  data() {
    //这里存放数据
    return {
      query: {},
      active: 0,
      title: "",
      payBtn: false,
      cancleBtn: false,
      message: "",
      list: [],
      showPage: false,
      order: {},
      result: {},
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onClickLeft() {
      this.$router.push({
        name: "home",
      });
    },
    format_money(value) {
      return "￥" + (value / 100).toFixed(2);
    },
    init(id) {
      api.getOrder({ out_trade_no: id }).then((res) => {
        if (res.status == 0) {
          this.order = res.result;
          this.list = JSON.parse(res.result.CartItem);
          this.message = res.result.Comment ? res.result.Comment : "暂无留言";
          let order = res.result;
          console.log('sasa',order.Status)
          switch (Number(order.Status)) {
            case 0:
              this.title = "待支付";
              this.payBtn = true;
               this.cancleBtn = true;
              break;
            case 1:
              this.title = "待发货";
              this.cancleBtn = true;
              break;
            case 2:
              order.IsReceived == 0 ? (this.title = "待收货") : "";
              if (order.IsReceived == 1 && order.IsPaid == 0) {
                this.title = "已收货,待付款";
                this.payBtn = true;
               
              }

              
              break;
            case 3:
              this.title = "已完成";
              break;
            case -4:
              this.title = "订单取消";
              break;
          }
          this.showPage = true;
        }
        console.log(res);
      });
    },

    toPage(id) {
      this.$router.push({
        name: "product",
        query: { id },
      });
    },

    wxpay() {
      api.wxpay({ out_trade_no: this.query.orderId }).then((res) => {
        console.log(res);
        let payarg = res;

        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener(
              "WeixinJSBridgeReady",
              this.onBridgeReady,
              false
            );
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", this.onBridgeReady);
          }
        } else {
          this.onBridgeReady(payarg);
        }
      });
    },

    onBridgeReady(params) {
      // const pay_params = JSON.parse(params);
      params.timeStamp = params.timeStamp.toString();
      WeixinJSBridge.invoke("getBrandWCPayRequest", params, (res) => {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          Dialog.alert({
            title: "提示",
            message: "支付成功,请等待发货",
          }).then(() => {
            this.$router.replace({
              name: "orderList",
            });
          });
        }
      });
    },

    // 取消订单
    cancleOrder() {
      Dialog.confirm({
        title: "提示",
        message: "确认取消订单吗",
      })
        .then(() => {
          let params = {
            Status: "-4",
          };
          api.updateOrder(this.order.out_trade_no, params).then((res) => {
            if (res.status == 0) {
              Dialog.alert({
                title: "提示",
                message: "取消订单,操作成功",
              }).then(() => {
                this.$router.replace({
                  name: "cart",
                });
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    //   获取订单id
    this.query = this.$route.query;
    this.init(this.query.orderId);
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped>
@color: #ffc053;

.order {
  background: #f2f2f2;
  min-height: calc(100vh);
  .van-nav-bar {
    background: @color;
  }
}
.items {
  .van-card {
    background: #fff;
    font-size: 14px;
    margin: 0;
  }
  .van-card__content {
    justify-content: space-evenly;
    .van-card__price {
      color: red;
      transform: scale(1.2);
    }
  }
  .van-cell-group {
    .van-cell {
      padding-top: 5px;
      .van-cell__title {
        color: #9f9f9f;
      }
    }
    .van-cell:first-child::before {
      position: absolute;
      box-sizing: border-box;
      content: " ";
      pointer-events: none;
      right: 0;
      top: 0;
      left: 16px;
      border-bottom: 1px solid #ebedf0;
      -webkit-transform: scaleY(0.5);
      transform: scaleY(0.5);
    }
  }
}
.select-cell {
  .van-cell__value span {
    color: black;
  }
  .total {
    .van-cell__value span {
      color: red;
      font-size: 20px;
    }
  }
}
.btn {
  width: 100vw;
  background: #fff;
  text-align: center;
  padding: 15px 0 15px;
  .van-button {
    width: 90%;
    margin: auto;
  }
}
</style>